import { Pipe, PipeTransform } from '@angular/core';
import {ClassEnergetiqueEnum} from '../pages/rt2012/parametrage-usages/enums/ClassEnergetiqueEnum';

@Pipe({
    name: 'classeEnergetique',
    standalone: false
})
export class ClasseEnergetiquePipe implements PipeTransform {

  transform(classEnergetiqueEnum: ClassEnergetiqueEnum): string {
    switch (classEnergetiqueEnum) {
      case ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_INCONNUE:
        return 'INCONNUE';
      case ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_B:
        return 'B';
      case ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A:
        return 'A';
      case ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS:
        return 'A+';
      case ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS_PLUS:
        return 'A++';
      case ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS_PLUS_PLUS:
        return 'A+++';
    }
  }

}
